import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { 
  Button, 
  Box, 
  useTheme, 
  useMediaQuery 
} from '@mui/material';
import { 
  Home, 
  MedicalServices, 
  People, 
  ContactPhone,
  WhatsApp,
  RateReview
} from '@mui/icons-material';

const Navigation: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Inicio', icon: <Home /> },
    { path: '/servicios', label: 'Servicios', icon: <MedicalServices /> },
    { path: '/equipo', label: 'Equipo', icon: <People /> },
    { path: '/testimonios', label: 'Testimonios', icon: <RateReview /> },
    { path: '/contacto', label: 'Contacto', icon: <ContactPhone /> },
  ];

  if (isMobile) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'stretch',
          gap: 0.5,
          px: 0.5
        }}
      >
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Button
              key={item.path}
              component={RouterLink}
              to={item.path}
              variant={isActive ? 'contained' : 'text'}
              sx={{ 
                flex: 1,
                flexDirection: 'column',
                minWidth: 0,
                px: 0.5,
                py: 1.5,
                borderRadius: 1.5,
                color: isActive ? 'white' : '#666',
                backgroundColor: isActive ? '#D2691E' : 'transparent',
                textTransform: 'none',
                fontSize: '0.7rem',
                fontWeight: isActive ? 'bold' : 'normal',
                gap: 0.4,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: isActive ? '#CD853F' : 'rgba(210, 105, 30, 0.08)',
                  color: isActive ? 'white' : '#D2691E',
                  transform: 'translateY(-2px)'
                },
                '&:active': {
                  transform: 'translateY(0)'
                }
              }}
            >
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                fontSize: '1.4rem',
                mb: 0.1
              }}>
                {item.icon}
              </Box>
              <Box component="span" sx={{ 
                lineHeight: 1.2,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%'
              }}>
                {item.label}
              </Box>
            </Button>
          );
        })}
      </Box>
    );
  }

  return (
    <Box sx={{ 
      display: 'flex', 
      gap: 2, 
      alignItems: 'center',
      marginLeft: 'auto' // Esto mueve el menú a la derecha
    }}>
      {navItems.map((item) => (
        <Button
          key={item.path}
          component={RouterLink}
          to={item.path}
          variant="text"
          sx={{ 
            color: location.pathname === item.path ? '#D2691E' : '#2C3E50',
            textTransform: 'none',
            fontSize: '1rem',
            fontWeight: location.pathname === item.path ? 'bold' : 500,
            borderBottom: location.pathname === item.path ? '2px solid #D2691E' : 'none',
            '&:hover': {
              backgroundColor: 'rgba(139, 69, 19, 0.1)',
              color: '#8B4513'
            }
          }}
        >
          {item.label}
        </Button>
      ))}
      <Button
        component="a"
        href="https://api.whatsapp.com/send?phone=573146628875&text=Hola%20vi%20tu%20sitio%20web%20quisiera%20mas%20informaci%c3%b3n%20"
        target="_blank"
        rel="noopener noreferrer"
        variant="contained"
        startIcon={<WhatsApp />}
        sx={{ 
          backgroundColor: '#D2691E', 
          color: 'white',
          borderRadius: '25px',
          px: 3,
          py: 1,
          textTransform: 'none',
          fontWeight: 'bold',
          '&:hover': { backgroundColor: '#CD853F' }
        }}
      >
        Cita
      </Button>
    </Box>
  );
};

export default Navigation; 